import { render, staticRenderFns } from "./ContactListItemSlotTemplate.vue?vue&type=template&id=4634aff6&scoped=true&"
import script from "./ContactListItemSlotTemplate.vue?vue&type=script&lang=js&"
export * from "./ContactListItemSlotTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ContactListItemSlotTemplate.vue?vue&type=style&index=0&id=4634aff6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4634aff6",
  null
  
)

export default component.exports